import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class AuditoriaService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    ObtenerAuditoriaCliente(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: auditoriaInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            auditoria {
              obtenerAuditoriaCliente(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    tipo_auditoria_codigo
                    rut_usuario
                    evento_auditoria_codigo
                    nombre_evento_auditoria
                    valor_antiguo
                    valor_nuevo
                    evento_auditoria_modulo_codigo
                    fecha
                    datoAntiguo
                    datoNuevo
                    nombreUsuario
                    nombrePropiedad
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.auditoria.obtenerAuditoriaCliente;
            callback({ mensajes, respuesta });
        });
    }
    ObtenerAuditoriaProducto(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: auditoriaInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            auditoria {
              obtenerAuditoriaProducto(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    tipo_auditoria_codigo
                    rut_usuario
                    evento_auditoria_codigo
                    nombre_evento_auditoria
                    valor_antiguo
                    valor_nuevo
                    evento_auditoria_modulo_codigo
                    fecha
                    datoAntiguo
                    datoNuevo
                    nombreUsuario
                    nombrePropiedad
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.auditoria.obtenerAuditoriaProducto;
            callback({ mensajes, respuesta });
        });
    }
    ObtenerAuditoriaDescuentosEspecial(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: auditoriaInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            auditoria {
              obtenerAuditoriaDescuentoEspecial(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    tipo_auditoria_codigo
                    rut_usuario
                    evento_auditoria_codigo
                    nombre_evento_auditoria
                    valor_antiguo
                    valor_nuevo
                    evento_auditoria_modulo_codigo
                    fecha
                    datoAntiguo
                    datoNuevo
                    nombreUsuario
                    nombrePropiedad
                    producto_sku
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.auditoria.obtenerAuditoriaDescuentoEspecial;
            callback({ mensajes, respuesta });
        });
    }
    ObtenerAuditoriaDescuentosMaximos(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: auditoriaInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            auditoria {
              obtenerAuditoriaDescuentoMaximo(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    tipo_auditoria_codigo
                    rut_usuario
                    evento_auditoria_codigo
                    nombre_evento_auditoria
                    valor_antiguo
                    valor_nuevo
                    evento_auditoria_modulo_codigo
                    fecha
                    datoAntiguo
                    datoNuevo
                    nombreUsuario
                    nombrePropiedad
                    producto_sku
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.auditoria.obtenerAuditoriaDescuentoMaximo;
            callback({ mensajes, respuesta });
        });
    }
}
AuditoriaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuditoriaService_Factory() { return new AuditoriaService(i0.ɵɵinject(i1.GraphQLClient)); }, token: AuditoriaService, providedIn: "root" });
